import Link from 'next/link';

import { useAppTranslation } from 'hooks/use-translates';

import styles from './form-navigation.module.scss';

type FormNavigationProps = {
	activeBtn: 'signin' | 'register';
	registerUrl?: string;
	signInUrl?: string;
	returnUrl?: string | null;
};

export const FormNavigation = ({
	activeBtn,
	registerUrl,
	signInUrl,
	returnUrl,
}: FormNavigationProps) => {
	const { t } = useAppTranslation();
	return (
		<div className={`display-medium bold ${styles.navigationButtons}`}>
			<Link
				href={{
					pathname: signInUrl || '/signin',
					query: returnUrl ? { returnUrl } : {},
				}}
				className={`${styles.linkButton} ${
					activeBtn === 'signin' ? styles.active : ''
				}`}
			>
				{t('common.signin_tab')}
			</Link>
			<Link
				href={{
					pathname: registerUrl || '/register',
					query: returnUrl ? { returnUrl } : {},
				}}
				className={`${styles.linkButton} ${
					activeBtn === 'register' ? styles.active : ''
				}`}
			>
				{t('common.register_tab')}
			</Link>
		</div>
	);
};

export default FormNavigation;
